(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      this.header = document.querySelector('.section-header .header');
  
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
  
      this.headerBounds = {};
  
      this.setHeaderHeight();
  
      window.matchMedia('(max-width: 990px)')
        .addEventListener('change', this.setHeaderHeight.bind(this));
  
      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }
  
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
  
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
  
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);
  
      this.createObserver();
    }
  
    setHeaderHeight() {
      requestAnimationFrame(() => {
        if (!this.header) return;
  
        const height = this.header.offsetHeight;
  
        document.documentElement.style.setProperty(
          '--header-height',
          `${height}px`
        );
      });
    }
  
    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  
    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });
  
      observer.observe(this.header);
    }
  
    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  
      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;
  
      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
  
          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);
  
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }
  
      this.currentScrollTop = scrollTop;
    }
  
    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }
  
    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }
  
    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }
  
    closeMenuDisclosure() {
      this.disclosures = this.disclosures || document.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }
  
    closeSearchModal() {
      this.searchModal = this.searchModal || document.querySelector('details-modal');
      if (!this.searchModal) return;
      this.searchModal.close(false);
    }
  }
  
  customElements.define('sticky-header', StickyHeader);
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    const popup = document.getElementById('nutrition-popup');
    const openBtn = document.querySelector('.nutrition-facts-btn');
    const closeBtn = document.querySelector('.nutrition-close');

    if (openBtn && popup && closeBtn) {
      openBtn.addEventListener('click', (e) => {
        e.preventDefault();
        popup.classList.add('active');
      });
      closeBtn.addEventListener('click', () => {
        popup.classList.remove('active');
      });
      popup.addEventListener('click', (e) => {
        if (e.target === popup) {
          popup.classList.remove('active');
        }
      });
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') {
          popup.classList.remove('active');
        }
      });
    }
  });

  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.btn-add-addon');
    if (!btn) return;

    const variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then((res) => res.json())
      .then(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (!cartDrawer) return;
        const drawerSectionId = cartDrawer.dataset.id || 'cart-drawer';
        fetch(`${window.Shopify.routes.root}cart?section_id=${drawerSectionId}`)
          .then((res) => res.text())
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');
            const newInner = html.querySelector('cart-drawer .drawer__inner');
            if (newInner) {
              cartDrawer.querySelector('.drawer__inner').innerHTML = newInner.innerHTML;
            }
            cartDrawer.classList.remove('is-empty');
            if (typeof cartDrawer.open === 'function') {
              cartDrawer.open();
            } else {
              cartDrawer.classList.add('active');
            }
          })
          .catch((err) => console.error('Drawer refresh error:', err));
      })
      .catch((err) => console.error('Add to cart error:', err));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-section"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const reviewSwiper = new Swiper('.reviews-section .testimonial-swiper', {
      loop: true,
      slidesPerView: 1.11,
      centeredSlides: true,
      spaceBetween: 12,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.reviews-section .swiper-button-next',
        prevEl: '.reviews-section .swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 2,
          centeredSlides: true,
          spaceBetween: 20,
        },
        1200: {
          slidesPerView: 3,
          centeredSlides: true,
          spaceBetween: 20,
        },
      },
    });
  });
  document.addEventListener('click', function (e) {
    const playBtn = e.target.closest('.play-btn-reviews');
    if (!playBtn) return;

    const videoMain = playBtn.closest('.video-main-reviews');
    if (!videoMain) return;

    const preview = videoMain.querySelector('.preview-image');
    const videoWrapper = videoMain.querySelector('.video-url');
    const video = videoWrapper?.querySelector('video');

    document.querySelectorAll('.video-main-reviews').forEach((wrapper) => {
      const v = wrapper.querySelector('video');
      const pv = wrapper.querySelector('.preview-image');
      const btn = wrapper.querySelector('.play-btn-reviews');
      const vw = wrapper.querySelector('.video-url');

      if (v) {
        v.pause();
        v.currentTime = 0;
      }
      if (pv) pv.style.display = '';
      if (btn) btn.style.display = '';
      if (vw) vw.style.display = 'none';
    });

    if (preview) preview.style.display = 'none';
    videoWrapper.style.display = 'flex';
    playBtn.style.display = 'none';

    if (video) video.play();
  });

  document.addEventListener(
    'pause',
    function (e) {
      if (e.target.tagName.toLowerCase() !== 'video') return;
      const wrapper = e.target.closest('.video-main-reviews');
      if (!wrapper) return;
      const preview = wrapper.querySelector('.preview-image');
      const playBtn = wrapper.querySelector('.play-btn-reviews');
      const videoWrapper = wrapper.querySelector('.video-url');
      if (preview) preview.style.display = '';
      if (playBtn) playBtn.style.display = '';
      if (videoWrapper) videoWrapper.style.display = 'none';
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
